export class ReportTypeConstants{
    public static AgentPortalFBOReports = 'Agent Portal FBO Reports';
    public static FBOReports = 'FBO Reports';
    public static FBOAccountPortalWidgets = 'FBO Account Portal Widgets';
    public static PreviousYear = 'previousYearValue';
    public static CurrentYear = 'currentYearValue';
    public static ChairmanBonusPDF = 'ChairmanBonus.pdf';
    public static MYEARNINGS = 'My_Earnings_';
    public static EAGLEMANAGER = 'EagleManager.pdf';
    public static FOREVER2DRIVE = 'Forever2Drive.pdf';
    public static GEMBONUS ='GemBonus.pdf';
    public static LEADERSHIPBONUS = 'LeadershipBonus.pdf';
    public static GLOBALRALLY = 'GlobalRallyIncentives.pdf';

}

export class FLP360ReportNameConstants {
    public static INCENTIVES = 'incentives';
}
export class ReportPathConstants {
    public static INCENTIVE_URL = '/external-reports/incentives';
}



// WEBPACK FOOTER //
// ./src/app/customerservice/constants/report-type.constants.ts